<template>
	<div class="ExternalCalls"
		v-loading.fullscreen.lock="$GVO.fullscreenLoading"
		element-loading-text="Загрузка данных..."
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)"	>
		<div class="filter-tag-row">
			<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Звонков: {{this.masObjects_total}}</span>
		</div>		
		<div class="col-md-12" v-show="bShowFilter">
			<ReFilter :masAllFilterParams="masAllFilterParams" 
			v-model="objGetParams" 
			v-on:filterapply="OnFilterApply"
			name="externalcalls"/>
		</div>
						
		<card>
			<el-table 
			:data="ApiData" 
			style="width: 100%"  
			@expand-change="rowClicked"
			@row-click="expandRow"
			@sort-change="onSortChange"
			:row-key="row => row.id"	
			:expand-row-keys="expandRowKeys"		
			ref="tableData"
			:row-class-name="tableRowClassName"

			>				
				<!-- <el-table-column
					width="200"
					label="RecID"
					property="RecID"
				></el-table-column>
				<el-table-column
					width="200"
					label="RecordId"
					property="RecordId"
				></el-table-column> -->
				
				
				<el-table-column 
					type="expand" 							
					sortable
					property="id"
					>
					<template v-slot="ApiData">
						<!-- <p v-if="ApiData.row.RecID != ''">RecID: {{ ApiData.row.RecID }}</p> -->
						<div>
							<ReAudioComponent
								v-if="ApiData.row.RecID != ''"
								:record="'/DATA/PhoneRec/'+ApiData.row.RecID"
								@reload="reloadAudio(ApiData.row)"
								@update-record="handleUpdateRecord(ApiData.row, $event)"
							/>
						</div>
					</template>
				</el-table-column>

				<el-table-column
					width="90"
					label="Запись звонка"
					property="id"
				>
					<template v-slot="ApiData">
						<span v-if="ApiData.row.RecID != ''" class="text-success font-weight-bold">Есть</span>

					</template>
				</el-table-column>

				<el-table-column				
				label="Сотрудник"
				sortable
				min-width="180"
				prop="subscribe_staff_fio">
					<template v-slot="scope">
						<!-- <a v-if="scope.row.CallerStaffId != -1" :href="'/data/staff/id/'+scope.row.CallerStaffId">{{scope.row.CallerStaffFio}}</a> -->
						<router-link :to="'/data/staff/id/'+scope.row.subscribe_staff_code">{{scope.row.subscribe_staff_fio}}</router-link>
						<!-- <a v-if="scope.row.CallerClientId != -1" :href="'/data/staff/id/'+scope.row.CallerClientId">{{scope.row.CallerClientFIO}}</a> -->
						<!-- <span >{{scope.row.CallerIDName}}</span> -->
					</template>
				</el-table-column>
				

				<el-table-column				
				label="ТЕЛ. ЗВОНЯЩЕГО"
				min-width="140"
				prop="CallerIDNum">
					<template v-slot="scope">
						{{ scope.row.CallerIDNum.replace(/.*\*/, '') }}
					</template>
				</el-table-column>

				<el-table-column
				label="ТИП ЗВОНКА"
				prop="CallFlow"
				min-width="140"
				sortable>
					<template v-slot="scope">
						<span class="CallFlow" :class="[{'CallFlowIn':scope.row.CallFlow == 'in'}, {'CallFlowOut':scope.row.CallFlow == 'out'},]"></span>
					</template>
				</el-table-column>
				
				

				<!-- <el-table-column
				sortable
				label="КОМУ ЗВОНИЛ CalledNumber"
				min-width="170"
				prop="CalledNumber">
					<template slot-scope="scope">
						<a v-if="scope.row.CallerStaffId == -1" :href="'/data/staff/id/'+scope.row.subscribe_staff_code">subscribe_staff_fio {{scope.row.subscribe_staff_fio}}</a>
					</template>
				</el-table-column> -->

				<el-table-column				
				label="КОМУ ЗВОНИЛ"				
				min-width="140"
				prop="CalledNumber">
					<template v-slot="scope">
						{{ scope.row.CalledNumber.replace(/.*\*/, '') }}
					</template>
				</el-table-column>

				<el-table-column
				label="РЕЗУЛЬТАТ"
				prop="CallStatus"
				min-width="140"
				sortable>
					<template v-slot="scope">
						<span v-if="scope.row.CallStatus == 'ANSWER'" class="text-success font-weight-bold">Ответил</span> 
						<span v-if="scope.row.CallStatus == 'CANCEL'">Отмена вызова</span> <!--звонящий отменил вызов до истечения таймера ожидания на сервере-->
						<span v-if="scope.row.CallStatus == 'BUSY'">Занято</span>
						<span v-if="scope.row.CallStatus == 'NOANSWER'">Истек таймер ожидания</span> <!--Истек таймер ожидания на сервере-->
						<span v-if="scope.row.CallStatus == 'CONGESTION'">Произошла ошибка во время вызова</span>
						<span v-if="scope.row.CallStatus == 'CHANUNAVAIL'">У вызываемого абонента отсутствует регистрация</span>
						<span v-if="scope.row.CallStatus == 'CALLING'">Звонит</span>
						
					</template>
				</el-table-column>

				<el-table-column
					width="230"
					label="КЛИЕНТ"					                   	
				>
					<template v-slot="ApiData">	
						<!-- <el-tooltip content="Добавить клиента" placement="top">
							<el-button class="no-border my-0">
							</el-button>
						</el-tooltip>	 -->
						<base-button v-if="ApiData.row.CallerClientId == '' || ApiData.row.CallerClientId == '-1' && !(ApiData.row.CalledNumber.includes('\*') && ApiData.row.CallerIDNum.includes('\*'))"  
						@click="AddClient(ApiData.row.CallFlow, ApiData.row.CallerIDNum, ApiData.row.CalledNumber)" 
						class="ml-3 btn btn-simple btn-success" 
						:key="ApiData.row.id" >
							Добавить клиента
						</base-button>			
						<router-link v-if="ApiData.row.CallerClientId == '' || ApiData.row.CallerClientId != '-1'" :to="'/data/clients/id/'+ApiData.row.CallerClientId+'?phoneint='+ApiData.row.concact_phone_INT">
						    {{ApiData.row.CallerClientFIO}} 
						</router-link>		
						<!-- <a v-if="ApiData.row.CallerStaffId != ''" :href="'/data/clients/id/'+ApiData.row.CallerStaffId">{{ApiData.row.CallerStaffFio}} </a>		 -->
					</template>
				</el-table-column>

				<el-table-column
				sortable
				label="Источник"
				min-width="200"
				prop="CalledDID">
					<template v-slot="scope">
						<div v-for="adsSource in adsSourceExtendMap" :key="adsSource.id" >
							<span v-if="adsSource.phone.slice(-10) == scope.row.CalledDID.slice(-10)" class="el-tag el-tag--small el-tag el-tag--primary">{{ adsSource.adsSource_id }}</span>
						</div>
					</template>
				</el-table-column>

				<el-table-column
				sortable
				label="КОГДА ЗВОНИЛ"
				min-width="160"
				prop="dwl_date">
					<template v-slot="scope">
						{{ $GVO.convertDateTimeFromMysql(scope.row.dwl_date) }}
					</template>
				</el-table-column>


			</el-table>
			
		</card>

		<Pagination :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masObjects_total)" 
			:perPage="parseInt(10)" 
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>


	</div>
</template>
<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn, Select, Option, Tooltip, Button } from 'element-ui';
// import { TabPane, Tabs } from 'src/components';
// import ReInputSearchDropType from 'src/our_modules/SearchSendObjects/ReInputSearchDropType.vue';
// import ReInputRange from "src/our_components/ReInputRange.vue";
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
// import ReHouseClassMap from 'src/our_components/ReHouseClassMap.vue';
import Pagination from 'src/our_components/RePagination';
import ReAudioComponent from "../our_components/ReAudioComponent.vue";

export default {
	name: 'externalcalls-page',
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		// TabPane, 
		// Tabs,
		[Option.name]: Option,
		[Select.name]: Select,
		[Tooltip.name]: Tooltip,	
		[Button.name]: Button,
		// ReInputSearchDropType,
		// ReInputRange,
		ReFilterBtn,
		ReFilter,
		// ReHouseClassMap,
		Pagination,
		ReAudioComponent,
	},
	data() {
		return {
			ApiData: [],
			bShowFilter: false,
			masAllFilterParams: this.currentFilterConfig(),
			// currentApiFormMethod: this.currentApiFormMethodComp(),
			// masAllFormParams: this.currentFormConfig(),
			masObjects_total: 0,
			// count2page: 10,
			objGetParams: {},
			objSortLoc: {order_field: 'dwl_date', sortOrder: 'descending'}, //ascending
			fullscreenLoading: false,
			strAudioLink: '',
			// strAudioLink:'/DATA/PhoneRec/${this.ApiData.RecID}.mp3',  
			objCall: {},
			expandRowKeys: [],
			clientCallNum: '',
			rowTypeName: '',
			adsSourceExtendMap: [],
			// adsSourceExtendMap: [],
		};
	},
	computed: {
  	},
	methods: {
        async reloadAudio(call){
            let res = await this.$GVO.Api.PhoneCallApi.call_check_file({flt:{id:call.id}});
            if(res.success == true){
                this.handleUpdateRecord(call, res.data.file_name);
            }
            // alert('Перезагружаем разговор '+call.id);

        },		
		tableRowClassName({row, rowIndex}) {
			if(row.RecID == '') {
				// console.log(objApi);
				return 'row-expand-cover';
			} else {
				return 'row-expand-hover';
			}
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('CALL_SUBSCRIBE.GET_FILTER',{})
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success){
					this.masAllFilterParams = objApi.config;
					eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
				}
			})
			.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		AddClient(CallFlow, CallerIDNum, CalledNumber){			
			if(CallFlow == 'in') {this.clientCallNum = CallerIDNum;} else {this.clientCallNum = CalledNumber;}
			// console.log('This clientCallNum is ' + this.clientCallNum);
			this.clientCallNum = this.clientCallNum.replace(/\+/, '');
			this.$router.push({path: `/data/clients/add?contact_value=${this.clientCallNum}`});		
		},
		getApiData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			let sortOrder = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				filter = this.objGetParams;
			}
			if (!this.$GVO.isEmpty(this.objSortLoc)) {
				sortOrder = {'order_field':`${this.objSortLoc.order_field} ${this.objSortLoc.sortOrder==='descending'?'desc':'asc'}`}
			}

			this.$GVO.ApiCall('CALL_SUBSCRIBE.GET',{flt:{...filter,...sortOrder}})
			.then((objApi) => {
				if(objApi.success === true){
					this.ApiData = [];
					this.masObjects_total = 0;
					if(objApi.data.length > 0){
						this.ApiData = this.$GVO.unlinkObject(objApi.data);
						// this.ApiData = objApi.data;
						// console.log(objApi);
						if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
					} else {
						// this.ApiData.call = this.ApiData.call.concat(this.$GVO.unlinkObject(objApi.data).call);
					}
				}else{
					this.ApiData = [];
					this.masObjects_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
		},
		getAdsSourceExtendMap(){
			this.$GVO.ApiCall('adsSourceExtendMap.GET',{flt:{'list':'true'}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.adsSourceExtendMap = objApi.data;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		
		rowClicked(row, expandedRows) {
			const id = row.id;
			const lastId = this.expandRowKeys[0];
			// disable mutiple row expanded 
			this.expandRowKeys = id === lastId ? [] : [id];
			
			if(expandedRows !='') {
				this.getCall(row.RecID);
				// console.log(row.RecID);
			} //else {this.strAudioLink ='';}
		},
		expandRow (row, event, column) {
			this.$refs.tableData.toggleRowExpansion(row);
		},
		getCall(RecID){
			/*
			Поправить код в методе. если надо использовать
			// let rowID = row.id;
            this.$GVO.ApiCall('GET_AUDIO_LINK',{obj:'PhoneCallApi', flt:{RecID:RecID}})
				.then((objApi) => {
					if(objApi.success){
						// this.ApiData.RecID = objApi.data;
						// console.log(this.ApiData.RecID);
						this.strAudioLink = `/DATA/PhoneRec/${RecID}.mp3`;
					}else{
						// this.strAudioLink = '';
					}
				})
				.catch((errorObjApi) => {console.log(errorObjApi);});
			*/
		},	
		OnFilterApply(data){
			// console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined'){
				delete this.objGetParams['p'];
			}

			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApiData();
		},
		onSortChange(objSort){
			//console.log(objSort);
			this.$emit('sort', objSort);
			this.objSortLoc.order_field = this.$GVO.unlinkObject(objSort.prop);
			this.objSortLoc.sortOrder = this.$GVO.unlinkObject(objSort.order);
			if(objSort.order != null){
				var queryParams = new URLSearchParams(window.location.search);
				queryParams.set("order_field", objSort.prop);
				queryParams.set("sortOrder", objSort.order);
				history.replaceState(null, null, "?"+queryParams.toString());
				this.objGetParams = this.$GVO.GetAllGet();
				this.OnFilterApply();
			}
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		SuccessGo(evt,dopParam){
			// console.log(evt,dopParam);
			//тут надо написать опустошитель формы
		},	
		// openFullScreen1(){
		// 	this.fullscreenLoading = true;
		// 	setTimeout(() => {
		// 	this.fullscreenLoading = false;
		// 	}, 3000);
		// },
		// ReloadCall(strLink){
        //     let call_start = this.$GVO.unlinkObject(this.objCall.call_start);
        //     this.objCall.call_start = null;
        //     this.$GVO.ApiCall('RELOAD_REC',{obj:'PhoneCallApi', flt:{link:strLink}})
		// 		.then((objApi) => {
		// 			if(objApi.success){
        //                 this.objCall.FilePath = strLink;
        //                 const iStart = strLink.indexOf('/PhoneRec/') + '/PhoneRec/'.length;
        //                 const iLen = strLink.length - iStart - 4;
        //                 //console.log(strLink.substr(iStart,iLen),iStart,iLen);
        //                 this.objCall.call_record = strLink.substr(iStart,iLen);
        //                 this.strAudioLink = `/DATA/PhoneRec/${this.objCall.call_record}.mp3?r=`+Math.random();
        //                 this.objCall.call_start = call_start;
		// 			}else{
						
		// 			}
		// 		})
		// 		.catch((errorObjApi) => {console.log(errorObjApi);});
        // },
        // onAudioErr(evt){
        //     //console.log(evt.srcElement.currentSrc.substr(evt.srcElement.currentSrc.indexOf('/DATA/'),evt.srcElement.currentSrc.length - evt.srcElement.currentSrc.indexOf('/DATA/')));
        //     this.ReloadCall(evt.srcElement.currentSrc.substr(evt.srcElement.currentSrc.indexOf('/DATA/'),evt.srcElement.currentSrc.length - evt.srcElement.currentSrc.indexOf('/DATA/')));
        // }
		
		handleUpdateRecord(row, newRecord) {
			// Обновляем RecID в объекте строки
			row.RecID = newRecord.replace('/DATA/PhoneRec/','');
		},		
	},
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		// console.log(this.objGetParams);
		if(typeof this.objGetParams.order_field != 'undefined'){
			this.objSortLoc.order_field = this.$GVO.unlinkObject(this.objGetParams.order_field);
			this.objSortLoc.sortOrder = this.$GVO.unlinkObject(this.objGetParams.sortOrder);
			this.$refs.tableData.sort(this.objSortLoc.prop,this.objSortLoc.order);
		}
		//this.getApiData();
		this.getAdsSourceExtendMap();
		
	}
};
</script>

<style>

.ExternalCalls .cellmap-wrapper, .ExternalCalls .map {
	width: 100%;	
	height: 100%;
}
.ExternalCalls .cellmap {
	width: 100%;
	height: 100%;
	background: rgba(16, 33, 63, 0.986);
}
.ExternalCalls .post {
	border: 1px solid transparent;
	border: 1px solid #01B0E0;
	border-radius: 0.2857rem;
	position: sticky;
	bottom: 0;		
}
.ExternalCalls .post >>> .card-body {padding: 0px 5px 15px 10px!important;}
.ExternalCalls .majorFilter-card {border: 1px solid #01b0e0;}
.ExternalCalls .majorFilter {display: flex; }
.ExternalCalls .firstFilter-row {display: flex; flex-wrap: wrap; width: 100%;}
.filter-shown {display: block;}
.filter-hidden {display: none;}
.ExternalCalls .bntGroup {
	display: flex;
	justify-content: flex-end;
}
.ExternalCalls .nav-pills .nav-item .nav-link {padding: 0px 20px;}
.ExternalCalls .form-options-group{
	flex-direction: row;
	width: 100%;
	align-items: center;
	flex-wrap: wrap;
}
.ExternalCalls .form-group {
	margin-bottom: 0px!important;
}
.CallFlow {
	display: inline-block;
	width: 25px;
	height: 25px;
	
}
.CallFlowIn {
	background: url('/img/icons/inCall.svg') no-repeat 50% 50%;
	background-size: contain;
}
.CallFlowOut {
	background: url('/img/icons/outCall.svg') no-repeat 50% 50%;
	background-size: contain;
}
.ExternalCalls .el-table .cell {
	word-break: break-word;
}
.ExternalCalls .row-expand-hover:hover {cursor:pointer;}
.ExternalCalls .row-expand-cover .el-table__expand-icon{visibility:hidden;}
.ExternalCalls .el-table__expand-icon {
    color: #00BF9A !important;
	font-size: 14px;
}

</style>
